<div class="popover-creation-compte-pro popover-generic-mobile bc-{{couleur}}" (click)="closePopup()">
  <div class="btn-close">
    <ion-icon slot="end" src="./assets/svg/close-popup.svg"></ion-icon>
  </div>
  <div class="typo-20-semibold-green" [innerHTML]="titre"></div>
</div>
